import { useQuery } from "@tanstack/react-query";
import sessionsService from "@/features/sessions/services/sessionsService";
import type { SessionWithDetails } from "@/features/sessions/types";
import DURATIONS from "@/shared/constants/durations";
import { sessionsKeys } from "./sessionsQueryKeys";

export function useSessionsForBook(bookId: string) {
    return useQuery<SessionWithDetails[], Error>({
        enabled: !!bookId,
        gcTime: DURATIONS.FIVE_MINUTES,
        queryFn: async () => {
            const sessions = await sessionsService.getSessionsForBook(bookId);
            return sessions.map((s) => ({ ...s, book: null, venue: null }));
        },
        queryKey: sessionsKeys.sessions.byBook(bookId),
        staleTime: DURATIONS.FIVE_MINUTES,
    });
}
